import { render, staticRenderFns } from "./CategoriasList.vue?vue&type=template&id=bd243658&"
import script from "./CategoriasList.vue?vue&type=script&lang=js&"
export * from "./CategoriasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports